var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"7","md":"9"}},[_c('v-card',{staticClass:"mx-auto mt-10",attrs:{"max-width":"560"}},[_c('auth-component')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }